import React, { Component } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { withRouter, Link } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { toast } from "react-toastify";
import { getPaginatedList, putData } from "../../services/baseServices";
import ConfirmationModal from "../common/Modal"
import { TABLES } from './Reconciliation'
import _ from "lodash";
import { DEBOUNCE_TIME } from "../../helper/env"

class ReturnRequests extends Component {
	constructor() {
		super();
		this.state = {
            questionnaires:[],
            question_details:{},
            locations:[],
            returnLocations: {},
			returnRequests: [],
			activePage: 1,
			per_page: 15,
			page: 1,
			query_params: {},
			isLoading: true
		};
	}
	handleModal = () => {
		this.setState({ showModal: !this.state.showModal });
	};

	handleReceivingModal = () => {
		this.setState({ showReceivingodal: !this.state.showReceivingodal });
	};

    getAttributes = (attrArray) => {
        let attrs = "";
        if(!!attrArray){
        attrArray.map((attr)=>(
        attrs+= attr.name+": "+attr.value+", "
        ))}
        return attrs.trimEnd();
    }
    
	getQueryParams = () => {
		let params = Object.assign(this.state.query_params, {
			per_page: this.state.per_page,
			page: this.state.page,
		});
		return params;
	};

	getRetuenList = (params) => {
        this.setState({ isLoading: true })
		getPaginatedList(this.props.url, params)
			.then((res) => {
				this.setState(
					{
						returnRequests: res?.data?.data,
						isLoading: false,
						per_page: res.headers["x-per-page"],
						total_data: parseInt(res.headers["x-total"]),
					},
					() => {}
				);
			})
			.catch((errMsg) => {
                this.setState({ isLoading: false })
				console.log("Error Message: ", errMsg);
			});
	};

	componentDidMount() {
		this.setState({ query_params: this.props.queryParams }, () => {
			this.getRetuenList(this.getQueryParams());
		})
	}

	handlePageChange = (pageNumber) => {
		this.setState({ page: pageNumber, activePage: pageNumber }, () => {
			this.getRetuenList(this.getQueryParams());
		});
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.queryParams.start_date_time.toString() !== this.props.queryParams.start_date_time.toString() 
            || prevProps.queryParams.end_date_time.toString() !== this.props.queryParams.end_date_time.toString() ) {
		    console.log(this.props.queryParams)
			this.setState({ query_params: this.props.queryParams }, () => {
            	this.getRetuenList(this.getQueryParams());
			})
        }
	}
   
    debouncedOnReceiveRR = _.debounce((returnId)=>{
        this.receiveReturnRequest(returnId)
    }, DEBOUNCE_TIME);

    handleWithDebounceReceiveRR = async (returnId) => {
        this.debouncedOnReceiveRR(returnId);
    }

    receiveReturnRequest = (returnId) => {
        this.setState(({isWaiting: true}), ()=>{
            putData(`return_orders/${returnId}/receive`, {})
            .then(res => {
                if(res.success) {
                    toast.success(res?.message)
                    this.props.onAfterAnyAction([TABLES.ORDER_SUMMARY, TABLES.ORDER_LIST])
                    this.getRetuenList(this.getQueryParams())
                } else {
                    toast.error(res.message)
                }
            })
            .catch(errMsg => {
                this.setState({isWaiting: false});
                toast.error(errMsg);
            });
        })
    }

	render() {
		return (
            <div className="main-content">
                <div className="page-header">
                    <h2 className="page-title">Returned Requests</h2>
                </div>
                {
                    this.state.isLoading ?
                        <div>Loading...</div>
                    :
                        <>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th style={{width: '75px'}}>Req. No</th>
                                    <th>Type</th>
                                    <th>Order No</th>
                                    <th>Item</th>
                                    <th>SKU</th>
                                    <th>Price (৳)</th>
                                    <th>Attributes</th>
                                    <th>Status</th>
                                    <th className='text-center' style={{width: '220px'}}>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.returnRequests?.length>0 ?
                                    this.state.returnRequests?.map((item,key) => (
                                    <tr key={key}>
                                        <th><Link to={`${process.env.PUBLIC_URL}/return-order/details/${item.return_id}`}>{item.return_id}</Link></th>
                                        <td>{item.return_type}</td>
                                        <td><Link to={`${process.env.PUBLIC_URL}/customerOrder/details/${item.customer_order_id}`}>{item.customer_order_id}</Link></td>
                                        <td>{item.product_details.title}</td>
                                        <td>{item.product_details?.sku}</td>
                                        <td>{item.product_details.price}</td>
                                        <td>
                                        {
                                            this.getAttributes(item?.product_details.product_attribute_values)
                                        }
                                        </td>
                                        <td>{item.return_status}</td>
                                        <td className="mx-auto text-center">
                                            {
                                                item.return_status === 'in_transit' ?
                                                    <OverlayTrigger
                                                    key="view"
                                                    placement="top"
                                                    overlay={
                                                    <Tooltip id={`tooltip-view`}>
                                                        Receive
                                                    </Tooltip>
                                                    }
                                                >
                                                    <ConfirmationModal 
                                                        customBtn = {true}
                                                        btnText = "Receive"
                                                        variant = "success"
                                                        title = "Receive return request" 
                                                        body = {`Are you sure to receive the Return Request(${item.return_id})?`} 
                                                        handleAction = {() =>this.handleWithDebounceReceiveRR(item.return_id)}/>
                                                </OverlayTrigger>
                                                :
                                                <Button size="sm" disabled>Receive</Button>
                                            }
                                           
                                        </td>
                                    </tr>
                                    ))
                                    :


                                    <tr><td colSpan={8}>No request found</td></tr>
                                }
                                </tbody>
                            </table>
                            {
                                this.state.returnRequests?.length > 0 &&
                                <div className="mt-3">
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.per_page}
                                        totalItemsCount={this.state.total_data}
                                        pageRangeDisplayed={10}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>
                            }
                        </>
                }
                
                
            </div>
		);
	}
}

export default withRouter(ReturnRequests);
